export default __webpack_public_path__ + "static/media/boxPolygon.9ad87317.png";